var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMemoryBloc
    ? _c("div", { staticClass: "geobeacon-wrapper" }, [
        _c("div", { staticClass: "param-ctn" }, [
          _c("span", { staticClass: "textinput-ctn geobeacon-ctn" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.memoryID,
                  expression: "memoryID"
                }
              ],
              staticClass: "value",
              attrs: { id: "GeoBeaconObjRef", type: "text", disabled: false },
              domProps: { value: _vm.memoryID },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.memoryID = $event.target.value
                }
              }
            }),
            _c(
              "div",
              {
                staticClass: "clickableMask",
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.copyTextToClipboard(_vm.memoryID)
                  }
                }
              },
              [_vm._v("Copy Object Reference")]
            )
          ])
        ])
      ])
    : _c("span", { staticClass: "textinput-ctn geobeacon-ctn" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.memoryID,
              expression: "memoryID"
            }
          ],
          staticClass: "value",
          attrs: { id: "GeoBeaconObjRef", type: "text", disabled: true },
          domProps: { value: _vm.memoryID },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.memoryID = $event.target.value
            }
          }
        }),
        _c(
          "div",
          {
            staticClass: "clickableMask clickableMask-mem",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.copyTextToClipboard(_vm.memoryID)
              }
            }
          },
          [_vm._v("Copy Object Reference")]
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }